import DiscountBanner from "../Home/DiscountBanner";
import Footer from "./Footers/Footer";
import Header from "./Headers/HeaderOne";

export default function Layout({ children, childrenClasses }) {
  return (
    <>
      <div className="w-full overflow-x-hidden">
        <Header />
        <div className={`w-full  ${childrenClasses || "pt-[30px] pb-[40px]"}`}>
          {children && children}
        </div>
        <DiscountBanner />
        <Footer />
      </div>
    </>
  );
}
